document.addEventListener('DOMContentLoaded', () => {
  const canReveal = 'IntersectionObserver' in window
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveal = (root) => {
    root.classList.add('is-reveal-ready');
    const observer = new IntersectionObserver((entries) => {
      for (const { isIntersecting, target } of entries) {
        if (!isIntersecting) continue;
        target.classList.add('is-visible');
        observer.unobserve(target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -10px 0px' });

    for (const item of root.querySelectorAll('[data-ppa-reveal]')) observer.observe(item);
  };

  const initVideos = (root) => {
    const videos = [...root.querySelectorAll('.ppa-stories__video')];
    if (!videos.length) return;

    root.addEventListener('play', ({ target }) => {
      document.dispatchEvent(new CustomEvent('theme:video:playing', { detail: { video: target } }));
    }, true);

    document.addEventListener('theme:video:playing', ({ detail }) => {
      for (const video of videos) {
        if (video !== detail.video) video.pause();
      }
    });
  };

  for (const root of document.querySelectorAll('[data-ppa-stories]')) {
    if (canReveal) initReveal(root);
    initVideos(root);
  }
});
